import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        username: '',
        contentType: '1'
    },
    mutations: {
        setUserName(state,username){
            state.username = username
        },
        setToken(state,token){
            state.token = token
        },
        setContentType(state,contentType){
            state.contentType = contentType
        }
    },
    actions: {}
})
